import Vue from "vue";

const state = Vue.observable({
  externalMedia: false
});

function updateConsent() {
  if (!window.CookieConsent) return;
  state.externalMedia =
    window.CookieConsent.acceptedCategory("external_media") === true;
}

export default {
  install(Vue, options = {}) {
    Vue.prototype.$hasExternalMediaConsent = () => state.externalMedia;

    window.addEventListener("load", () => {
      if (!window.CookieConsent) return;

      const lang =
        document.documentElement.lang === "pt" ||
        document.documentElement.lang === "pt-PT"
          ? "pt"
          : "en";

      window.CookieConsent.run({
        page_scripts: true,

        categories: {
          necessary: {
            enabled: true,
            readOnly: true
          }
        },

        language: {
          default: "pt",
          translations: {
            en: {
              consentModal: {
                title: "We use cookies",
                description:
                  "This website uses cookies to ensure proper functionality and to load external media.",
                acceptAllBtn: "Accept all",
                acceptNecessaryBtn: "Only necessary",
                showPreferencesBtn: "Preferences"
              },
              preferencesModal: {
                title: "Cookie preferences",
                acceptAllBtn: "Accept all",
                acceptNecessaryBtn: "Only necessary",
                savePreferencesBtn: "Save preferences",
                closeIconLabel: "Close",
                sections: [
                  {
                    title: "Necessary cookies",
                    description:
                      "These cookies are essential for the website to function properly.",
                    linkedCategory: "necessary",
                    cookieTable: {
                      headers: {
                        name: "Cookie",
                        purpose: "Purpose",
                        duration: "Duration",
                        provider: "Provider"
                      },
                      body: [
                        {
                          name: "cc_cookie",
                          purpose:
                            "Stores the user's cookie consent preferences.",
                          duration: "6 months",
                          provider: "This website"
                        }
                      ]
                    }
                  }
                ]
              }
            },

            pt: {
              consentModal: {
                title: "Utilizamos cookies",
                description:
                  "Este website utiliza cookies para garantir o seu correto funcionamento e para carregar conteúdos externos.",
                acceptAllBtn: "Aceitar tudo",
                acceptNecessaryBtn: "Apenas necessários",
                showPreferencesBtn: "Preferências"
              },
              preferencesModal: {
                title: "Preferências de cookies",
                acceptAllBtn: "Aceitar tudo",
                acceptNecessaryBtn: "Apenas necessários",
                savePreferencesBtn: "Guardar preferências",
                closeIconLabel: "Fechar",
                sections: [
                  {
                    title: "Cookies necessários",
                    description:
                      "Estes cookies são essenciais para o funcionamento do website.",
                    linkedCategory: "necessary",
                    cookieTable: {
                      headers: {
                        name: "Cookie",
                        purpose: "Finalidade",
                        duration: "Duração",
                        provider: "Fornecedor"
                      },
                      body: [
                        {
                          name: "cc_cookie",
                          purpose:
                            "Armazena as preferências de consentimento de cookies do utilizador.",
                          duration: "6 meses",
                          provider: "Este website"
                        }
                      ]
                    }
                  }
                ]
              }
            }
          }
        }
      });

      updateConsent();

      window.addEventListener("cc:initialized", updateConsent);
      window.addEventListener("cc:onConsent", updateConsent);
      window.addEventListener("cc:onChange", updateConsent);
    });
  }
};



// WEBPACK FOOTER //
// ./src/plugins/cookieconsent.js